import React, { Component, Fragment } from 'react';
import { Label, FormGroup, InputGroup, InputGroupAddon, Input, Button, Fade } from 'reactstrap';
import { string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Icon from '../Icon/Icon';

class IframeConstructorCode extends Component {
  static propTypes = {
    code: string,
  };

  state = {
    copied: false,
  };

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleCopy = () => {
    this.setState(
      () => ({ copied: true }),
      () => {
        setTimeout(() => {
          this._mounted && this.setState(() => ({ copied: false }));
        }, 1200);
      },
    );
  };

  render() {
    const { code } = this.props;
    const { copied } = this.state;
    return (
      <FormGroup>
        <Label>
          {code ? (
            <Fragment>
              <FormattedMessage id="iframe_constructor.code.label" defaultMessage="Embed code:" />
              <Fade in={copied} tag="span" className="copy-message">
                <FormattedMessage id="flow.copied" defaultMessage="copied to clipboard" />
              </Fade>
            </Fragment>
          ) : (
            <FormattedMessage
              id="iframe_constructor.code.empty"
              defaultMessage="Save the flow to get the embed code"
            />
          )}
        </Label>

        {code && (
          <InputGroup>
            <Input className="stream-link" value={code} readOnly />
            <InputGroupAddon addonType="append">
              <CopyToClipboard text={code} onCopy={this.handleCopy}>
                <Button type="button" color="primary" onClick={this.handleClick}>
                  <Icon type="copy" />{' '}
                  <FormattedMessage id="flow.form.link.copy" defaultMessage="Copy" />
                </Button>
              </CopyToClipboard>
            </InputGroupAddon>
          </InputGroup>
        )}
      </FormGroup>
    );
  }
}

export default IframeConstructorCode;
